import ReactRating from "react-rating";
import {css, Theme, useTheme} from "@emotion/react";

import {borderRadius, calculateRemSize as crs, p} from "@pg-design/helpers-css";
import {StarFillIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    score: number;
    isReadOnly?: boolean;
    onClick?: (value: number) => void;
    className?: string;
    showScore?: boolean;
}

export function Rating(props: IProps) {
    const {score, isReadOnly, onClick, className, showScore} = props;
    const theme = useTheme();

    const formattedScore = new Intl.NumberFormat("pl-PL", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(score);

    return (
        <div className={className} css={ratingWrap}>
            <div css={rating}>
                <ReactRating
                    initialRating={score}
                    readonly={isReadOnly}
                    onClick={onClick}
                    fullSymbol={<StarFillIcon size="2.8" wrapperSize="2.8" wrapperColor="transparent" fill={theme.colors.primary} />}
                    emptySymbol={<StarFillIcon size="2.8" wrapperSize="2.8" wrapperColor="transparent" fill="#fff" />}
                />
            </div>
            {showScore && (
                <Text variant="body_copy_2" css={scoreText}>
                    {formattedScore}
                </Text>
            )}
        </div>
    );
}

const ratingWrap = css`
    display: flex;
    flex-wrap: wrap;
    gap: ${crs(1.5)};
`;

const scoreText = (theme: Theme) => css`
    background: ${theme.colors.primary};
    font-weight: 700;
    ${p(0.5)};
    ${borderRadius(1)};
`;

const rating = css`
    min-width: 140px;
`;
